import Typography from '@mui/material/Typography';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import MessageBox from '../../../../util/messageBox';
import React, {useEffect, useState} from 'react';
import {useAgyleConfigStyles} from '../../agyle_configuration';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import useOpenState from '../../../../hooks/useOpenState';
import {setSnackbar} from '../../../../store/reducers/globals';
import {FormLabel} from '@mui/material';
import AgyleCheckBox from '../../../../components/ui/checkbox/agyleCheckBox';
import _ from 'lodash';
import {DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST} from '../configDefaultValues';

const TriggersConfigurationCleaningRequest = ({cfg, handleSaveConfig}) => {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [triggers, setTriggers] = useState(DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST);
    const [isModified, setIsModified] = useState(false);

    // Opening states
    const [isWarningOpen, openWarning, closeWarning] = useOpenState(false, true);

    // Load from config
    useEffect(() => {
        if (cfg?.value?.triggers) {
            setTriggers(cfg?.value?.triggers);
        }
    }, [cfg]);

    const onSave = () => {
        handleSaveConfig('triggers', triggers);
        setIsModified(false);
    };

    const onDefault = () => {
        closeWarning();
        setTriggers(DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST);
        dispatch(setSnackbar({type: 'info', message: t('Default settings restored.')}));
        setIsModified(true);
    };

    const renderSection = (type) => {
        const handleChange = (event) => {
            const {checked, name} = event.target;
            setTriggers(prevState => ({
                ...prevState,
                [name]: checked,
            }));
            setIsModified(true);
        };

        return (
            <div className={classes.smallContext}>
                <FormLabel>
                    {t('Patient')} {_.startCase(type)}
                </FormLabel>

                <div>
                    <AgyleCheckBox
                        name={type}
                        label={t('Enabled')}
                        value={triggers[type]}
                        onChange={handleChange}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            <Typography variant="subtitle2" sx={{marginBottom: '10px'}}>
                {t('Set default triggers for Cleaning Requests.')}
            </Typography>

            <div>
                {renderSection('discharge')}
                {renderSection('transfer')}
                {renderSection('offWard')}
            </div>

            <div className={classes.action}>
                <AgyleButton
                    onClick={openWarning}
                    variant="contained"
                >
                    {t('Reset to default')}
                </AgyleButton>

                <AgyleButton
                    onClick={onSave}
                    variant="contained"
                    disabled={!isModified}
                >
                    {t('Save changes')}
                </AgyleButton>
            </div>

            <MessageBox
                open={isWarningOpen}
                onClose={closeWarning}
                title={t('Confirmation')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={onDefault}
                message={t('Are you sure you want to restore the default settings?')}
            />
        </>
    );
};

export default TriggersConfigurationCleaningRequest;